window.components = {};
require('./components/contact-form');
require('./components/products');
require('./components/accordion-item');
require('./components/modals/product');
require('./components/modals/popup-line-product');
require('./components/sections/calculator');
require('./components/sections/questions');
require('./components/sections/faq');
require('./components/sections/calculator-form');
require('./components/search');
require('./components/newsletter');
require('./components/recaptchaV3');
